var searchEmpty = 'fx_2d2fb1e5_5c39g80';

export { searchEmpty };
//# sourceMappingURL=searchEmpty.vanilla.mjs.map
